<template>
  <div>
    <div class="wizard-confirmation mt-20" v-if="!payment_error">
      <div class="wizard-confirmation-container">
        <div class="box_image flex-1 text-center" :class="{ 'h-fit': registration.payment_method === 'transfer' }"
        >
          <img src="/img/confirmation.webp">
          <div class="px-5 pb-12" :class="{ 'mt-20': courseselected.type === 'other' }">
            <img class="mt-10 mb-8 mx-auto" src="/img/icons/check-blue.svg">
            <h4 class="mb-5">{{ $trans.get("wizard.step5.title") }}</h4>
            <div v-if="courseselected.type !== 'other'">
              <p>{{ $trans.get("wizard.step5.subtitle") }}</p>
              <button class="btn btn-primary px-6 mt-5"  @click="goToForm">{{ $trans.get("wizard.step5.btn") }}</button>
            </div>
          </div>
        </div>
        <div class="resume flex-1">
          <div class="resume-column lg:pr-6">
            <h5 class="mb-3">{{ $trans.get("wizard.step5.co-title") }}</h5>
            <!-- Datos de curso -->
            <p class="font-bold mb-2">{{ $trans.get("wizard.step5.title1") }}</p>
            <p>
              {{ $trans.get("wizard.step5.text1") }}
              <b>{{ courseselected.name && courseselected.name[lang] }} - {{ this.registration.type_course.charAt(0).toUpperCase() + this.registration.type_course.slice(1) }}</b>
            </p>
            <p>{{ $trans.get("wizard.step5.text3") }} <b>Ramon y cajal</b></p>
            <p>{{ $trans.get("wizard.step5.text2") }} <b>{{$trans.get('wizard.step5.'+registration.dues)}}</b></p>

            <!-- Datos personales -->
            <p class="mt-5 mb-3 font-bold">{{ $trans.get("wizard.step5.title4") }}</p>
            <p>{{ $trans.get("wizard.step5.name_last_name") }} {{registration.personal.name}}<span></span></p>
            <p>{{ $trans.get("wizard.step5.email") }} {{registration.personal.email}}<span></span></p>
            <p>{{ $trans.get("wizard.step5.phone") }} {{registration.personal.phone}}<span></span></p>

            <div v-if="registration.payment_method === 'transfer'">
              <p class="mt-5 mb-3 font-bold">{{ $trans.get("wizard.step5.title4") }}</p>
              <p>{{ $trans.get("wizard.step5.text5") }} <span>Ramon y cajal</span></p>
              <p>{{ $trans.get("wizard.step5.text8") }} <span>{{ redsys.Ds_AuthorisationCode }}</span></p>
            </div>

            <!-- card payment -->
            <div v-if="registration.payment_method == 'card'">
                <p class="mt-5 mb-3 font-bold">{{$trans.get('wizard.step5.title2')}}</p>
                <p>{{$trans.get('wizard.step5.text4')}} <span>3338883736367-1</span></p>
                <p>{{$trans.get('wizard.step5.text5')}} <span>{{ lang === 'ca' ? 'Ramon y Cajal (Espanya)' : 'Ramon y Cajal (España)' }}</span></p>
                <p>{{$trans.get('wizard.step5.text6')}} <span>https://www.ramonycajal.com/es</span></p>
                <p>{{$trans.get('wizard.step5.text7')}} <span> {{ redsys.Ds_Order }}</span></p>
                <p>{{$trans.get('wizard.step5.text8')}} <span>{{ redsys.Ds_AuthorisationCode }}</span></p>
                <p>{{$trans.get('wizard.step5.text9')}} <span>{{ lang === 'ca' ? 'Prova rebut' : 'Prueba recibo' }}</span></p>
            </div>
            <div v-if="registration.payment_method == 'card'" class="resume-price">
              <p class="mt-5 mb-2 font-bold">{{ $trans.get("wizard.step5.title5") }}</p>
              <p class="font-bold">{{registration.total | currency}} <span>{{ $trans.get("wizard.step5.text12") }}</span></p>
            </div>
          </div>
                <!-- transfer payment -->
      <div v-if="registration.payment_method == 'transfer'" class="transfer-info">
        <!-- <div class="flex-1 hidden md:block"></div> -->
        <div class="mt-8 wizard-confirmation-right">
          <p class="font-bold mb-5">{{$trans.get('wizard.step5.title3')}}</p>
          <p class="mb-5 text-bank">{{ $trans.get('wizard.step5.choose_bank_text') }}</p>
          <div class="mt-3 mb-8">
            <p class="font-bold">{{$trans.get('wizard.step4.bank')}}<span class="font-normal"> BBVA Banco Bilbao Vizcaya Argentaria</span></p>
            <p class="font-bold">{{$trans.get('wizard.step4.transfer-name')}}<span class="font-normal"> Escola de Formació Professional Ramón i Cajal</span></p>
            <p class="font-bold">{{ $trans.get('wizard.step4.transfer-number') }}<span class="font-normal"> IBAN ES10 0182 6319 9902 0008 0717</span></p>
            <p class="font-bold">BIC:<span class="font-normal"> BBVAESMM</span> </p>
          </div>
          <div>
            <p class="font-bold">{{$trans.get('wizard.step4.bank')}}<span class="font-normal"> Caixa Bank</span></p>  
            <p class="font-bold">{{$trans.get('wizard.step4.transfer-name')}}<span class="font-normal"> Escola de Formació Professional Ramón i Cajal</span></p>
            <p class="font-bold">{{ $trans.get('wizard.step4.transfer-number') }}<span class="font-normal"> IBAN ES38 2100 0920 3802 0026 7119</span></p>
            <p class="font-bold">BIC:<span class="font-normal"> CAIXESBBXXX</span> </p>
          </div>
          <div>
            <div class="my-8">
                <p class="font-bold mt-3">{{$trans.get('wizard.step4.concept')}}</p>
                <p>{{$trans.get('wizard.step4.concept-text')}}</p>
            </div>
            <p class="font-bold mt-3 text-orange">{{$trans.get('wizard.step4.info')}}</p>
            <div class="resume-price">
              <p class="mt-5 mb-2 font-bold">{{ $trans.get("wizard.step5.title5") }}</p>
              <p class="font-bold">{{registration.total | currency}} <span>{{ $trans.get("wizard.step5.text12") }}</span></p>
            </div>
          </div>
        </div>
      </div>
        </div>
      </div>
    </div>
    <div v-if="payment_error" class="flex justify-center items-center text-center">
      <h2>{{ $trans.get('wizard.error-msg')}}</h2>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data: () => {
    return {
        registrationData: window.registration,
        redsys: window.redsys ? JSON.parse(window.redsys) : "",
        payment_error: window.payment_error,
        lang: window.appLocale,
    };
  },
  computed: {
    ...mapGetters(["getCourses"]),
    courseselected() {
      return this.getCourses
        ? this.getCourses.filter(
            (course) => course.id === this.registration.course_id
          )[0]
        : {};
    },
    registration() {
      if (this.registrationData) return this.registrationData;
      return this.$store.getters.getRegistration
    },
  },
  methods: {
    goToForm() {
      const code = this.registration.code; 
      const lang = this.lang || 'es';
      const url = `/` + lang + `/form?code=` + code;

      window.location.href = url; 
    }
  }

};
</script>
<style lang="scss" scoped>
.wizard-confirmation {
  padding-bottom: 5rem;
  &-container {
    max-width: 1100px;
    display: flex;
    gap: 2rem;
    justify-content: center;
    margin: auto;

    @media (max-width: 768px) {
        flex-direction: column;;
      }
    
    .box_image {
      background-color: #edf1f4;
      &.h-fit {
        height: fit-content;
      }
    }

    .resume {

      .resume-column {
        width: 100%;
        background-color: white;
        padding: 1.8rem;
        h5 {
          margin-bottom: 0.5rem;
          font-size: 18px;
        }
      }
    }
  }
  .confirmation-alert {
    background-color: #00559a;
    color: white;
    margin-top: 2rem;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    .text-container {
      padding: 2rem 1rem;
      text-align: center;
      @media (min-width: 1024px) {
        padding: 2rem;
      }
    }
  }
  .text-orange {
    color: #e96639;
    font-weight: bold;
  }

}

.transfer-info {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1100px;
  gap: 1.5rem;
  margin: 0 auto;
}

.wizard-confirmation-right {
    padding: 1.5rem;
    background-color: white;

  .text-bank {
    color: #00559a;
  }
}
</style>
